import { filter } from 'lodash';
import { formatDataValue } from 'utils/formatFns';

export const accessoryFields = {
  accessoryCode: {
    label: 'Code',
    getValue: (data) => ({
      accessoryCode: data?.accessoryCode,
      accessoryPricePhase: data?.accessoryPricePhase,
    }),
    formatValue: ({ accessoryCode, accessoryPricePhase }) =>
      `${formatDataValue({ value: accessoryCode })} ${formatDataValue({
        value: accessoryPricePhase,
      })}`,
  },
  accessoryDescription: {
    label: 'Description',
    getValue: (data) => data?.accessoryDescription,
    formatValue: (value) => formatDataValue({ value }),
  },
  accessoryStatus: {
    label: 'Status',
    getValue: (data) => data?.installationStatus,
    formatValue: (value) => formatDataValue({ value }),
  },
  accessoryType: {
    label: 'Type',
    getValue: (data) => data?.subAccessories,
    formatValue: (value) => (value ? 'Package' : ''),
  },
  fioInstallation: {
    label: 'FIO Installation',
    getValue: (data) => filter(data?.generalInfo?.accessoryDetail, { accessoryType: 'F' }),
    formatValue: (accessories) => {
      if (!accessories || accessories.length === 0) {
        return null;
      }
      return accessories
        .map(
          (data) =>
            `${formatDataValue({ value: data?.accessoryCode })} ${formatDataValue({
              value: data?.accessoryPricePhase,
            })}`,
        )
        .join(' ');
    },
  },
  ilaInstallation: {
    label: 'ILA Installation',
    getValue: (data) =>
      filter(
        data?.generalInfo?.accessoryDetail,
        (item) =>
          item?.accessoryType === 'P' &&
          (item?.installationStatus === 'Inline Installed' ||
            item?.installationStatus === 'Inline Pending'),
      ),
    formatValue: (accessories) => {
      if (!accessories || accessories.length === 0) {
        return null;
      }
      return accessories
        .map(
          (data) =>
            `${formatDataValue({ value: data?.accessoryCode })} ${formatDataValue({
              value: data?.accessoryPricePhase,
            })}`,
        )
        .join(' ');
    },
  },
  ppoInstallation: {
    label: 'PPO Installation',
    getValue: (data) =>
      filter(
        data?.generalInfo?.accessoryDetail,
        (item) =>
          item?.accessoryType === 'P' &&
          (item?.installationStatus === 'Offline Installed' ||
            item?.installationStatus === 'Offline Pending' ||
            !item?.installationStatus),
      ),
    formatValue: (accessories) => {
      return accessories
        .map(
          (data) =>
            `${formatDataValue({ value: data?.accessoryCode })} ${formatDataValue({
              value: data?.accessoryPricePhase,
            })}`,
        )
        .join(' ');
    },
  },
};
